import React, { useState } from "react";
import "../Layouts/header.css";
import "../../Components/CommonContainer/common.css";
import { Link, useLocation } from "react-router-dom";
import hlogo from "../../Assets/images/h-logo.png"; // ✅ Imported logo

const Header = () => {
  const [activeItem, setActiveItem] = useState("Home");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "About us", path: "/about-us" },
    { name: "Jewellery", path: "/jewellery" },
    { name: "Furniture", path: "/furniture" },
    { name: "Articles", path: "/articles" },
    { name: "Contact Us", path: "/contact-us" },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleItemClick = (item) => {
    setActiveItem(item);
    setIsMenuOpen(false);
  };

  return (
    <div className="heaader-main-contianer">
      <div className="common-width-main-container header-container">
        <div className="menu-m-card">
            <img src={hlogo} alt="logo" className="mobile-logo" />
          <div className="hamburger" onClick={toggleMenu}>
            <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
            <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
            <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
          </div>

        
        </div>

        <ul className={`nav-items-ul ${isMenuOpen ? "show" : ""}`}>
          {/* Left side */}
          {menuItems.slice(0, 3).map((item) => (
            <li
              key={item.name}
              className={location.pathname === item.path ? "nav-item active" : "nav-item"}
              onClick={() => handleItemClick(item.name)}
            >
              <Link to={item.path}>{item.name}</Link>
            </li>
          ))}

          {/* Center Logo */}
          <li className="logo-item">
            <Link to="/">
              <img src={hlogo} alt="Logo" className="header-logo" />
            </Link>
          </li>

          {/* Right side */}
          {menuItems.slice(3).map((item) => (
            <li
              key={item.name}
              className={location.pathname === item.path ? "nav-item active" : "nav-item"}
              onClick={() => handleItemClick(item.name)}
            >
              <Link to={item.path}>{item.name}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Header;
